import * as SentryBrowser from "@sentry/browser";
import { SEVERITY } from '../constants';
function BrowserLoggerEngine(options) {
    let logger;
    return {
        init: () => {
            SentryBrowser.init({
                ignoreErrors: ["ResizeObserver loop limit exceeded"],
                denyUrls: ["localhost"],
                // Set tracesSampleRate to 1.0 to capture 100%
                // of transactions for performance monitoring.
                // We recommend adjusting this value in production
                tracesSampleRate: 1.0,
                beforeSend: (event, hint) => {
                    if (options.consoleLog) {
                        console.log("SENTRY:", (hint === null || hint === void 0 ? void 0 : hint.originalException) || (hint === null || hint === void 0 ? void 0 : hint.syntheticException));
                        return null;
                    }
                    return event;
                },
                ...options,
            });
            logger = SentryBrowser;
        },
        log: ({ level, message, context }) => {
            try {
                logger.withScope((scope) => {
                    scope.setLevel(level || SEVERITY.log);
                    scope.setContext("context", context !== null && context !== void 0 ? context : null);
                    logger.captureMessage(message);
                });
            }
            catch (error) {
                console.trace(error);
                console.trace(message, level);
            }
        },
        logException: (exception, context) => {
            logger.captureException(exception, context);
        },
        setUser: (user) => {
            SentryBrowser.setUser(user);
        },
        clearUser: () => {
            SentryBrowser.configureScope((scope) => scope.setUser(null));
        },
        setTag: (key, value) => {
            SentryBrowser.setTag(key, value);
        },
        setTags: (tags) => {
            SentryBrowser.setTags(tags);
        },
        setContext: (name, ctx) => {
            SentryBrowser.setContext(name, ctx);
        },
    };
}
export default BrowserLoggerEngine;
//# sourceMappingURL=browser-logger-engine.js.map